export const CONTINUITY_UNLOAD = 'CONTINUITY_UNLOAD'

export const unload = (companyKey) => ({
  type: CONTINUITY_UNLOAD,
  companyKey
})
